import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { API_URI } from "../Common/data";

function NewServices() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchServices = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_URI}/our-services`);
      if (res.status === 200) {
        setServices(res.data?.data);
      }
    } catch (error) {
      toast.error("Error fetching services");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchServices();
  }, []);

  const renderServiceItem = (service, index) => (
    <div className="updated-service-shell" key={`${service.heading}-${index}`}>
      <div className="updated-service">
        <img
          src={service.image}
          alt={service.heading || `Service ${index + 1}`}
        />
        <div className="cirb-div">
          <h2>{service.heading}</h2>
        </div>
      </div>
    </div>
  );

  return (
    <div className="blacks">
      <div className="updatedwhy-heading">
        <h2>Our Services</h2>
      </div>
      <br />
      <br />

      {loading ? (
        <p>Loading...</p>
      ) : (
        <div className="updated-services">
          <div className="updated-services-track">
            {[...services, ...services].map((service, index) =>
              renderServiceItem(service, index)
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default NewServices;
